<template>
    <div class="deposit-request approved-thm">
        <div class="deposit-request-sec">
            <div class="thm-heading">
                <img loading="lazy" src="@/assets/images/request-right-icon.webp" alt="request-right-icon">
                <h3>{{ walletDetails.name }} request Approved</h3>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "DepositRequestApproved",
    props:['walletDetails'],
}
</script>